import { API_BASE_URL } from 'src/globals';
import { DSR_TEMPLATE, DSR_HEADERS, DSR_TEMPLATE_SEARCH } from 'src/api/routes';
import {
  GET,
  POST,
  UPDATE,
  DELETE,
} from 'src/api/apiHandler';
import {
  DeleteTemplateReq,
  EditTemplateReq,
} from './DsrTemplate.types';

const createTemplate = (body) => {
  return POST(`${API_BASE_URL}${DSR_TEMPLATE}`, body);
};

const editTemplate = (body) => {
  return UPDATE(`${API_BASE_URL}${DSR_TEMPLATE}`, body);
};

const fetchTemplates = (params) => {
  return GET(`${API_BASE_URL}${DSR_TEMPLATE}`, params);
};

const deleteTemplates = (params: DeleteTemplateReq) => {
  return DELETE(`${API_BASE_URL}${DSR_TEMPLATE}`, params);
};

const fetchDsrHeaders = () => {
  return GET(`${API_BASE_URL}${DSR_TEMPLATE}${DSR_HEADERS}`);
};

const searchDsrTemplate = (params) => {
  return GET(`${API_BASE_URL}${DSR_TEMPLATE_SEARCH}`, params);
};

export {
  editTemplate,
  fetchTemplates,
  createTemplate,
  fetchDsrHeaders,
  deleteTemplates,
  searchDsrTemplate,
};
